import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useRouting() {
  const route = useRoute();

  const routeMetadata = computed(() => {
    return route.meta || {};
  });

  const routePrefix = computed(() => {
    return routeMetadata.value.prefix || '';
  });

  const routePageName = computed(() => {
    if (!route.name || typeof route.name !== 'string') {
      return undefined;
    }
    return route.name.split('-')[0];
  });

  const getLanguageSwitchLink = (language: HgSupportedLanguage) => {
    // Prefer name-based location when available so vue-router can resolve it
    // through the routing table; otherwise fall back to the raw path.
    const fallback = route.name
      ? { name: route.name, params: route.params, query: route.query, hash: route.hash }
      : { path: route.path, query: route.query, hash: route.hash };

    // The initGuards beforeEach ensures every route has getLanguageSwitchLink set at runtime,
    // but we keep the typeof check here as a safety net for isolated unit tests and
    // unexpected edge cases. ?? handles the case where the meta function returns undefined/null.
    if (typeof route.meta?.getLanguageSwitchLink !== 'function') return fallback;
    return route.meta.getLanguageSwitchLink(route, language) ?? fallback;
  };

  const getPageRoute = (
    pageName: string,
    language: HgSupportedLanguage,
    options?: any,
    ignorePrefix = false,
  ) => {
    return {
      name: `${pageName}-${language}${ignorePrefix ? '' : routePrefix.value}`,
      ...options,
    };
  };

  return {
    routeMetadata,
    routePrefix,
    routePageName,
    getLanguageSwitchLink,
    getPageRoute,
  };
}
